import { gql, useQuery } from "@apollo/client";

const GetTeacherStudentReviewsQuery = gql`
  query getTeacherStudentReviews(
    $teacherId: String!
    $startDate: String
    $endDate: String
  ) {
    getTeacherStudentReviews(
      teacherId: $teacherId
      startDate: $startDate
      endDate: $endDate
    ) {
      simulatedStudentScore
      students {
        userId
        decayedAvg
        reviews {
          id
          reviewedAtUtc
          clearanceScore
          involvementScore
          comfortableScore
          teacherAvg
          decayWeight
        }
      }
    }
  }
`;

export type StudentReviewItem = {
  id: string;
  reviewedAtUtc: string;
  clearanceScore: number;
  involvementScore: number;
  comfortableScore: number;
  teacherAvg: number;
  decayWeight: number;
};

export type StudentReviewGroup = {
  userId: string;
  decayedAvg: number;
  reviews: StudentReviewItem[];
};

export type TeacherStudentReviewsResult = {
  simulatedStudentScore: number;
  students: StudentReviewGroup[];
};

export function useTeacherStudentReviews(
  teacherId: string,
  startDate?: string,
  endDate?: string,
) {
  const { data, loading } = useQuery(GetTeacherStudentReviewsQuery, {
    variables: { teacherId, startDate, endDate },
    fetchPolicy: "cache-and-network",
  });

  const result = data?.getTeacherStudentReviews as
    | TeacherStudentReviewsResult
    | undefined;

  return {
    result,
    loading,
  };
}
